import Role from 'myfitworld-model/dist/enums/Role';

const makeArrayContainsAnyArgumentForUserList = (roles: Role[], selectedOrganizationId?: string) => [
  ...roles.map(role => ({id: selectedOrganizationId, role: role})),
  ...roles.map(role => ({id: selectedOrganizationId, role: role, archived: false })),
  ...roles.map(role => ({id: selectedOrganizationId, role: role, archived: true }))
];

export default makeArrayContainsAnyArgumentForUserList;
